
import { Checkbox } from "@/components/ui/checkbox";
import { Label } from "@/components/ui/label";
import { useState, useEffect } from "react";


export function CheckboxField({
  label,
  checked,
  onChange,
  disabled = false,
  className,
  indeterminate = false,
}) {
  const [isChecked, setIsChecked] = useState(checked || false);

  useEffect(() => {
    setIsChecked(checked || false);
  }, [checked]);

  const handleChange = (value) => {
    setIsChecked(value);
    onChange?.(value);
  };

  return (
    <div className={`flex items-center space-x-2 ${className || ""}`}>
      <Checkbox
        id={label}
        checked={isChecked}
        onCheckedChange={handleChange}
        disabled={disabled}
        indeterminate={indeterminate}
      />
      {label && (
        <Label
          htmlFor={label}
          className={`cursor-pointer capitalize ${disabled ? "opacity-50" : ""}`}
        >
          {label}
        </Label>
      )}
    </div>
  );
}
